/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Analysis
 */
export interface Analysis {
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof Analysis
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof Analysis
   */
  readonly updated?: Date;
  /**
   *
   * @type {number}
   * @memberof Analysis
   */
  parameter: number;
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  limitSymbol?: string | null;
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  unit?: string | null;
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  value?: string | null;
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  reportingLimit?: string | null;
  /**
   *
   * @type {AnalysisStatusQualityControlEnum}
   * @memberof Analysis
   */
  statusQualityControl?: AnalysisStatusQualityControlEnum | null;
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  analysisProcess: string;
  /**
   *
   * @type {string}
   * @memberof Analysis
   */
  dataOwner: string;
}

/**
 * @export
 */
export const AnalysisStatusQualityControlEnum = {
  Afgekeurd: "afgekeurd",
  Goedgekeurd: "goedgekeurd",
  Onbeslist: "onbeslist",
  Onbekend: "onbekend",
} as const;
export type AnalysisStatusQualityControlEnum =
  (typeof AnalysisStatusQualityControlEnum)[keyof typeof AnalysisStatusQualityControlEnum];

/**
 * Check if a given object implements the Analysis interface.
 */
export function instanceOfAnalysis(value: object): value is Analysis {
  if (!("parameter" in value) || value["parameter"] === undefined) return false;
  if (
    (!("analysisProcess" in (value as Record<string, any>)) &&
      !("analysis_process" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["analysisProcess"] === undefined &&
      (value as Record<string, any>)["analysis_process"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function AnalysisFromJSON(json: any): Analysis {
  return AnalysisFromJSONTyped(json, false);
}

export function AnalysisFromJSONTyped(json: any, ignoreDiscriminator: boolean): Analysis {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    parameter: json["parameter"],
    limitSymbol:
      json["limit_symbol"] === undefined
        ? undefined
        : json["limit_symbol"] === null
        ? null
        : json["limit_symbol"],
    unit: json["unit"] === undefined ? undefined : json["unit"] === null ? null : json["unit"],
    value: json["value"] === undefined ? undefined : json["value"] === null ? null : json["value"],
    reportingLimit:
      json["reporting_limit"] === undefined
        ? undefined
        : json["reporting_limit"] === null
        ? null
        : json["reporting_limit"],
    statusQualityControl:
      json["status_quality_control"] === undefined
        ? undefined
        : json["status_quality_control"] === null
        ? null
        : json["status_quality_control"],
    analysisProcess: json["analysis_process"],
    dataOwner: json["data_owner"],
  };
}

export function AnalysisToJSON(json: any): Analysis {
  return AnalysisToJSONTyped(json, false);
}

export function AnalysisToJSONTyped(
  value?: Omit<Analysis, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    parameter: value["parameter"],
    limit_symbol: value["limitSymbol"],
    unit: value["unit"],
    value: value["value"],
    reporting_limit: value["reportingLimit"],
    status_quality_control: value["statusQualityControl"],
    analysis_process: value["analysisProcess"],
    data_owner: value["dataOwner"],
  };
}
